<template>
    <div id = "officemanagement">
        <NavBarHome></NavBarHome>
        <br>
        <v-container>
            <v-row >
                

                     <TreeView></TreeView>

            </v-row>

        </v-container>


    </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import { authTokenService } from "@/services/authTokenService.js";
import { authService } from "@/services/authService.js";
import { CONSTANTS } from "../common/constants";
import router from "@/router";

export default {
  name: "OfficeManagement",
  components: {},
  data: () => ({}),
  methods: {
    logout () {
      authService.logout();
    },
    start () {
      router.push({ name: "home" });
    },
    admin () {
      router.push({ name: "admin" });
    }
  },
  mounted () {
    const me = this;
    const claims = authTokenService.getClaims();
  }
};
</script>